<template>
    <reconciliation-step-template
        :nextStep="nextStep"
        :previousStep="previousStep"
        :loading="loading"
        @next="goToNextStep"
        @previous="$emit('previous')"
    >
        <template #content>
            <el-form
                ref="step3Form"
                labelPosition="top"
                :model="formStep"
                :inlineMessage="true"
                labelWidth="120px"
            >
                <p class="fs-3 semibold mt-4 mb-2">
                    1 - {{ $l10n.__('Définissez la colonne de date de transaction') }}
                </p>
                <el-form-item label="" prop="dateColumn" :error="errors.get('dateColumn')">
                    <div v-loading="loading" class="step-container-table border-black">
                        <TableSelectableColumns
                            v-model="modelValue.template.date.columns"
                            :lines="csv"
                            :max="1"
                        />
                    </div>
                </el-form-item>

                <p class="fs-3 semibold mt-4 mb-2">
                    2 - {{ $l10n.__('Définissez le format de la date de transaction') }}
                </p>
                <el-form-item label="" prop="dateFormat" :error="errors.get('dateFormat')">
                    <SelectInput
                        v-model="modelValue.template.date.arguments.format"
                        mode="edit"
                        :options="dateFormats"
                    />
                </el-form-item>
            </el-form>
        </template>
    </reconciliation-step-template>
</template>

<script>
import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue';
import ImportStepsMixins from './ImportStepsMixins';
import BankReconciliationImport from 'api/bankreconciliationImport';
import FormMixin from 'mixins/FormMixins';
import SelectInput from 'vcomponents/inputs/SelectInput.vue';

export default {
    components: {
        TableSelectableColumns,
        SelectInput,
    },
    mixins: [ImportStepsMixins, FormMixin],
    data() {
        return {
            selectedColumns: [],
            dateFormats: [
                {
                    label: this.$l10n.__('JJMMAAAA'),
                    value: 'dmY',
                },
                {
                    label: this.$l10n.__('JJ/MM/AAAA'),
                    value: 'd/m/Y',
                },
                {
                    label: this.$l10n.__('JJ/MM/AA'),
                    value: 'd/m/y',
                },
                {
                    label: this.$l10n.__('AAAA-MM-JJ'),
                    value: 'Y-m-d',
                },
                {
                    label: this.$l10n.__('AAAAMMJJ'),
                    value: 'Ymd',
                },
            ],
            loading: true,
            formStep: {
                dateColumn: this.modelValue.template.date.columns,
                dateFormat: this.modelValue.template.date.arguments.format,
            },
        };
    },
    created() {
        BankReconciliationImport.getTemplate(this.idImport)
            .then((response) => {
                this.$emit('update-csv', response.csv);
                this.$emit('update-import-id', this.idImport);
                if (Object.keys(response.template).length > 0) {
                    this.modelValue.template = {
                        ...this.modelValue.template,
                        ...response.template,
                    };
                }
                this.loading = false;
            })
            .catch((error) => {
                Push.error(error, false);
            });
    },
    methods: {
        goToNextStep() {
            this.checkMinColumns('date', 1) ? this.$emit('next') : false;
        },
    },
};
</script>
